import api from './api';

/**
 * Media Library API — CRUD calls follow the branchAPI/voucherAPI shape
 * (shared `api` instance, which already attaches the auth + CSRF headers).
 * The upload call reuses that same instance but overrides the timeout the
 * way uploadAPI.js does for its multipart calls (default 10s is too short
 * for a file upload).
 */
export const mediaAPI = {
    getAll: (params = {}) => api.get('/media', { params }),
    getById: (id) => api.get(`/media/${id}`),
    delete: (id) => api.delete(`/media/${id}`),

    // tenantId is only needed by a superadmin (who has no tenant of their
    // own) — the server always prefers the caller's own tenant otherwise.
    upload: (file, { tenantId, branchId, altText, tags } = {}) => {
        const formData = new FormData();
        formData.append('file', file);
        if (tenantId) formData.append('tenantId', tenantId);
        if (branchId) formData.append('branchId', branchId);
        if (altText) formData.append('altText', altText);
        if (tags) formData.append('tags', tags);
        return api.post('/media/upload', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: 60000,
        });
    },

    crop: (id, { left, top, width, height }) => api.post(`/media/${id}/crop`, { left, top, width, height }),
    resize: (id, { width, height }) => api.post(`/media/${id}/resize`, { width, height }),
    optimize: (id, { quality, format } = {}) => api.post(`/media/${id}/optimize`, { quality, format }),
};

export default mediaAPI;
